/* global axios */
import ApiClient from './ApiClient';

// Dashboard de feedbacks/correções da IA (account-level). index lista os reports
// de erro; resolve marca como resolvido.
class AiAgentFeedbacksAPI extends ApiClient {
  constructor() {
    super('ai_agent_feedbacks', { accountScoped: true });
  }

  resolve(id, resolved) {
    return axios.patch(`${this.url}/${id}`, { resolved });
  }
}

export default new AiAgentFeedbacksAPI();
